import { FC } from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { observer } from 'mobx-react-lite';

import { Trans } from '@libs/i18n';
import { DomainOverviewCard as DomainOverviewCardType } from '@libs/types';
import { FolderSimpleIcon, PercentIcon } from '@phosphor-icons/react';

interface Props {
  item: DomainOverviewCardType;
}

export const DomainOverviewCard: FC<Props> = observer(({ item }) => {
  const theme = useTheme();
  return (
    <Paper
      elevation={1}
      variant="outlined"
      sx={{
        width: '100%',
        borderRadius: 2,
        mt: 3,
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 1.5,
            mb: 0.5,
            minWidth: 0,
          }}
        >
          <FolderSimpleIcon color={theme.palette.blue[500]} size={20} style={{ flexShrink: 0 }} />
          <Typography
            variant="textSM_medium"
            sx={{
              minWidth: 0,
            }}
          >
            {item.name}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              backgroundColor: 'yellow.100',
              gap: 0.5,
              px: 1,
              py: 0.5,
              borderRadius: 3,
              border: `1px solid`,
              borderColor: 'yellow.400',
              flexShrink: 0,
            }}
          >
            <PercentIcon color={theme.palette.yellow[700]} size={16} />
            <Typography variant="textXS_semiBold" sx={{ color: 'yellow.700' }}>
              {(Number(String(item.weight).replace(',', '.')) * 100).toFixed(1).replace(/\.0$/, '')}
            </Typography>
          </Box>
          <Typography
            variant="textXS_regular"
            sx={{
              marginInlineStart: 'auto',
            }}
          >
            {item.evidenceCount} <Trans i18nKey="assessments.new.card.evidenceCount" /> ·{' '}
            {item.minEstimatedTime}-{item.maxEstimatedTime} <Trans i18nKey="app.common.min" />
          </Typography>
        </Box>
        <Typography variant="textXS_regular" sx={{ color: 'text.tertiary' }}>
          {item.description}
        </Typography>
      </Box>
    </Paper>
  );
});
